/**
 * Selector de idioma — envía el formulario de localización al cambiar el <select>.
 * Delegado + guard de reentrada (el snippet se puede encolar más de una vez).
 * Ver snippets/iurop-language-selector.liquid.
 */
(function () {
  'use strict';
  if (window.__iuropLocaleReady) return;
  window.__iuropLocaleReady = true;

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-locale-select]');
    if (!sel || !sel.form) return;
    sel.form.submit();
  });
})();
